import { Link } from 'react-router-dom';
import { categories } from '@/mocks/hoobuyData';

export default function Footer() {
  const topCategories = categories.slice(0, 7);
  const bottomCategories = categories.slice(7);

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300">
              Hoobuy
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  Início
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  Hoobuy Sheet
                </a>
              </li>
              <li>
                <Link to="/artigo/guia-completo-hoobuy-spreadsheet-2026" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  Guia Completo
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300">
              Categorias
            </h3>
            <ul className="space-y-2.5">
              {topCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {cat.namePt}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300">
              Mais Categorias
            </h3>
            <ul className="space-y-2.5">
              {bottomCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {cat.namePt}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 pb-2 border-b border-background-300">
              Legal
            </h3>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-foreground-500">Termos de Uso</span>
              </li>
              <li>
                <span className="text-sm text-foreground-500">Política de Privacidade</span>
              </li>
              <li>
                <span className="text-sm text-foreground-500">Disclaimer</span>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-primary-600 hover:text-primary-700 transition-colors font-medium whitespace-nowrap">
                  Buy It Now →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
              Hoobuy Motorcycles
            </p>
            <p className="text-xs text-foreground-500 mt-1">
              Links atualizados para compradores inteligentes
            </p>
          </div>
          <div className="flex flex-col items-end gap-2">
            <p className="text-xs text-foreground-500">
              &copy; 2026 hoobuy.motorcycles — Todos os direitos reservados
            </p>
            <p className="text-xs text-foreground-400 max-w-md text-right">
              Este conteúdo é apenas informativo. Não vendemos produtos. As marcas mencionadas pertencem aos seus respectivos proprietários.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}